import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Typography from "@mui/material/Typography";

export default function GeneratedEconomyCard({ resume }) {
  return (
    <CustomContainer
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
      }}
    >
      <MonetizationOnIcon color="primary" sx={{ fontSize: "100px" }}/>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          width: "220px"
        }}
      >
        <Typography
          color="primary"
          component="p"
          sx={{ fontWeight: 600 }}
          variant="h4"
        >
          { !!resume.economiaGerada ? `R$${ resume.economiaGerada.replace('.', ',') }` : 'R$ -' }
        </Typography>
        <Typography sx={{ fontSize: '20px' }}>
          {/* ECONOMIA
          <br />
          GERADA */}
          (EM BREVE)
        </Typography>
      </Box>
    </CustomContainer>
  );
};
